import React from 'react'

import { datadogRum } from '@datadog/browser-rum'
import { Button, ButtonColorVariant, Col, Grid } from '@gousto-internal/citrus-react'

import { Resubscribe } from '../Resubscribe'
import { Section } from '../components/Section'
import { frequencyMapping } from '../enum/frequency'
import { orderABoxSection, resubscribeSection } from '../subscriptionsSectionsContent'
import { trackSubscriptionSettingsChange } from '../tracking'
import { OrderABox } from './sections/OrderABox'

export type Props = {
  accessToken: string
  showResubscribe?: boolean
  setShowResubscribe: (showResubscribe: boolean) => void
  numPortions: number
  frequency: number
}

export const PausedSubscription = ({
  accessToken,
  showResubscribe,
  setShowResubscribe,
  numPortions,
  frequency,
}: Props) => {
  const handleBackClick = () => setShowResubscribe(false)
  const handleSubmitCompleted = () => setShowResubscribe(false)

  const handleResubscribeCtaClick = () => {
    setShowResubscribe(true)
    trackSubscriptionSettingsChange({
      settingName: 'reactivate_subscription_cta',
      action: 'click',
    })({
      portion_size: numPortions,
      frequency: frequencyMapping[frequency],
    })
    datadogRum.addAction('resubscribe_clicked')
  }

  if (showResubscribe) {
    return (
      <Resubscribe
        data-testid="resubscribe-screen"
        accessToken={accessToken}
        onBackClick={handleBackClick}
        onSubmitCompleted={handleSubmitCompleted}
      />
    )
  }

  return (
    <Grid columnGap={[0, 6]} paddingH={[0, 3]}>
      <Col size={[12, 6]}>
        <Section
          title={resubscribeSection.title}
          subTitle={resubscribeSection.subTitle}
          testingSelector={resubscribeSection.testingSelector}
        >
          <Button
            data-testid="resubscribe-cta"
            onClick={handleResubscribeCtaClick}
            colorVariant={ButtonColorVariant.Primary}
            width="100%"
            id="resubscribe-cta"
          >
            Reactivate subscription
          </Button>
        </Section>
      </Col>
      <Col size={[12, 6]}>
        <Section
          title={orderABoxSection.title}
          subTitle={orderABoxSection.subTitle}
          testingSelector={orderABoxSection.testingSelector}
        >
          <OrderABox />
        </Section>
      </Col>
    </Grid>
  )
}
